import { Card, CardContent, Grid } from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";
import React from "react";
import Chart from "react-google-charts";
const styles = (theme) => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
  typo: {
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    marginRight: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
});

class AgentUser extends React.Component {
  state = {
    expanded: "panel1",
  };

  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;
    const agentOnline = <span className={classes.bulletOnline}>•</span>;
    const agentOffline = <span className={classes.bulletOffline}>•</span>;
    return (
      <React.Fragment>
        <Paper className={classes.root} elevation={1}>
          <Typography variant="h5" component="h3" className={classes.typo}>
            Tổng quan
          </Typography>
          <Grid container>
            <Grid item lg={4}>
              <Card>
                <CardContent>
                  <Chart
                    width={"100%"}
                    height={"200px"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={[
                      ["Tổng số chiến dịch", "Kết quả"],
                      ["Kết Thúc", 3],
                      ["Hành động", 7],
                    ]}
                    options={{
                      title: "Báo cáo thông tin chiến dịch",
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Tổng số chiến dịch</TableCell>
                        <TableCell>Kết thúc</TableCell>
                        <TableCell>Hoạt động</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>10</TableCell>
                        <TableCell>3</TableCell>
                        <TableCell>7</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>
            <Grid item lg={4}>
              <Card>
                <CardContent>
                  <Chart
                    width="100%"
                    height={"200px"}
                    chartType="ScatterChart"
                    loader={<div>Loading Chart</div>}
                    data={[
                      ["Generation", "Descendants"],
                      [0, 1],
                      [1, 33],
                      [2, 269],
                      [3, 2013],
                    ]}
                    options={{
                      title:
                        "Total number of connected calls in a week / month",
                      crosshair: { trigger: "both", orientation: "both" },
                      trendlines: {
                        0: {
                          type: "polynomial",
                          degree: 3,
                          visibleInLegend: true,
                          labelInLegend: "Trend",
                        },
                      },
                    }}
                    rootProps={{ "data-testid": "4" }}
                  />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Tổng số cuộc gọi</TableCell>
                        <TableCell>Chưa gọi</TableCell>
                        <TableCell>Kết nối</TableCell>
                        <TableCell>Không kết nối</TableCell>
                        <TableCell>PTP</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>9,365</TableCell>
                        <TableCell>1,000</TableCell>
                        <TableCell>6,365</TableCell>
                        <TableCell>2,000</TableCell>
                        <TableCell>xxx</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>
            <Grid item lg={4}>
              <Card>
                <CardContent>
                  <Chart
                    width="100%"
                    height={"200px"}
                    chartType="AreaChart"
                    loader={<div>Loading Chart</div>}
                    data={[
                      [
                        "Tổng số ĐTV",
                        "Làm việc",
                        "Nghỉ",
                        "Connected agent",
                        "PTP",
                      ],
                      ["8h - 9h", 8497, 4744, 4700, 2490],
                      ["9h - 10h", 4347, 2232, 2902, 397],
                      ["10h - 11h", 2902, 397, 4645, 3699],
                      ["11h - 12h", 2232, 4645, 3699, 4744],
                    ]}
                    options={{
                      title: "Chart of campaign supervision",
                      hAxis: { titleTextStyle: { color: "#333" } },
                      vAxis: { minValue: 0, title: "Calls" },
                      // For the legend to fit, we make the chart area smaller
                      chartArea: { width: "50%", height: "70%" },
                      // lineWidth: 25
                    }}
                    // For tests
                    rootProps={{ "data-testid": "1" }}
                  />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Tổng số ĐTV</TableCell>
                        <TableCell>Làm việc</TableCell>
                        <TableCell>Nghỉ</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>46</TableCell>
                        <TableCell>36</TableCell>
                        <TableCell>10</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Paper>
        <ExpansionPanel
          expanded={expanded === "panel1"}
          onChange={this.handleChange("panel1")}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              Chiến dịch: Giới thiệu gói khuyến mãi A
            </Typography>
            <Typography className={classes.secondaryHeading}>
              Từ ngày: 01/05/2019 đến ngày 31/05/2019
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container>
              <Grid item lg={8}>
                <Card>
                  <CardContent>
                    <Chart
                      width="100%"
                      height={"200px"}
                      chartType="ScatterChart"
                      loader={<div>Loading Chart</div>}
                      data={[
                        ["Generation", "Descendants"],
                        [0, 1],
                        [1, 33],
                        [2, 269],
                        [3, 2013],
                      ]}
                      options={{
                        title:
                          "Total number of connected calls in a week / month",
                        crosshair: { trigger: "both", orientation: "both" },
                        trendlines: {
                          0: {
                            type: "polynomial",
                            degree: 3,
                            visibleInLegend: true,
                            labelInLegend: "Trend",
                          },
                        },
                      }}
                      rootProps={{ "data-testid": "4" }}
                    />
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Tổng số cuộc gọi</TableCell>
                          <TableCell>Chưa gọi</TableCell>
                          <TableCell>Kết nối</TableCell>
                          <TableCell>Không kết nối</TableCell>
                          <TableCell>PTP</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>9,365</TableCell>
                          <TableCell>1,000</TableCell>
                          <TableCell>6,365</TableCell>
                          <TableCell>2,000</TableCell>
                          <TableCell>xxx</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={4}>
                <Card>
                  <CardContent>
                    <Chart
                      width="100%"
                      height={"200px"}
                      chartType="AreaChart"
                      loader={<div>Loading Chart</div>}
                      data={[
                        [
                          "Period of time",
                          "Total",
                          "Connected",
                          "Connected agent",
                          "PTP",
                        ],
                        ["8h - 9h", 8497, 4744, 4700, 2490],
                        ["9h - 10h", 4347, 2232, 2902, 397],
                        ["10h - 11h", 2902, 397, 4645, 3699],
                        ["11h - 12h", 2232, 4645, 3699, 4744],
                      ]}
                      options={{
                        title: "Chart of campaign supervision",
                        hAxis: { titleTextStyle: { color: "#333" } },
                        vAxis: { minValue: 0, title: "Calls" },
                        // For the legend to fit, we make the chart area smaller
                        chartArea: { width: "50%", height: "70%" },
                        // lineWidth: 25
                      }}
                      // For tests
                      rootProps={{ "data-testid": "1" }}
                    />
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Tổng số ĐTV</TableCell>
                          <TableCell>Làm việc</TableCell>
                          <TableCell>Nghỉ</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>46</TableCell>
                          <TableCell>36</TableCell>
                          <TableCell>10</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <Typography variant="h5" component="h3" className={classes.typo}>
              Điện thoại viên
            </Typography>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <Card>
              <CardContent>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Điện thoại viên</TableCell>
                      <TableCell>Máy lẻ</TableCell>
                      <TableCell>Trạng thái làm việc</TableCell>
                      <TableCell>Trạng thái cuộc gọi</TableCell>
                      <TableCell>Số cuộc gọi được phân bổ trong ngày</TableCell>
                      <TableCell>Chưa gọi</TableCell>
                      <TableCell>Kết nối</TableCell>
                      <TableCell>Không kết nối</TableCell>
                      <TableCell>PTP</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Nguyễn Văn A (3000)</TableCell>
                      <TableCell>1000</TableCell>
                      <TableCell>Đang gọi telesale</TableCell>
                      <TableCell>Đang gọi ra</TableCell>
                      <TableCell>100</TableCell>
                      <TableCell>30</TableCell>
                      <TableCell>50</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>xxx</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Nguyễn Văn B (3001)</TableCell>
                      <TableCell>1000</TableCell>
                      <TableCell>Đang gọi telesale</TableCell>
                      <TableCell>Đang kết nối</TableCell>
                      <TableCell>100</TableCell>
                      <TableCell>50</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>20</TableCell>
                      <TableCell>xxx</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Nguyễn Thị C (3002)</TableCell>
                      <TableCell>1000</TableCell>
                      <TableCell>Đang gọi telesale</TableCell>
                      <TableCell>Đang nghỉ</TableCell>
                      <TableCell>100</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>80</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>xxx</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel
          expanded={expanded === "panel2"}
          onChange={this.handleChange("panel2")}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              Chiến dịch: Giới thiệu sự kiện ABC
            </Typography>
            <Typography className={classes.secondaryHeading}>
              Từ ngày: 01/05/2019 đến ngày 31/05/2019
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container>
              <Grid item lg={8}>
                <Card>
                  <CardContent>
                    <Chart
                      width="100%"
                      height={"200px"}
                      chartType="ScatterChart"
                      loader={<div>Loading Chart</div>}
                      data={[
                        ["Generation", "Descendants"],
                        [0, 1],
                        [1, 33],
                        [2, 269],
                        [3, 2013],
                      ]}
                      options={{
                        title:
                          "Total number of connected calls in a week / month",
                        crosshair: { trigger: "both", orientation: "both" },
                        trendlines: {
                          0: {
                            type: "polynomial",
                            degree: 3,
                            visibleInLegend: true,
                            labelInLegend: "Trend",
                          },
                        },
                      }}
                      rootProps={{ "data-testid": "4" }}
                    />
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Tổng số cuộc gọi</TableCell>
                          <TableCell>Chưa gọi</TableCell>
                          <TableCell>Kết nối</TableCell>
                          <TableCell>Không kết nối</TableCell>
                          <TableCell>PTP</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>9,365</TableCell>
                          <TableCell>1,000</TableCell>
                          <TableCell>6,365</TableCell>
                          <TableCell>2,000</TableCell>
                          <TableCell>xxx</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={4}>
                <Card>
                  <CardContent>
                    <Chart
                      width="100%"
                      height={"200px"}
                      chartType="AreaChart"
                      loader={<div>Loading Chart</div>}
                      data={[
                        [
                          "Period of time",
                          "Total",
                          "Connected",
                          "Connected agent",
                          "PTP",
                        ],
                        ["8h - 9h", 8497, 4744, 4700, 2490],
                        ["9h - 10h", 4347, 2232, 2902, 397],
                        ["10h - 11h", 2902, 397, 4645, 3699],
                        ["11h - 12h", 2232, 4645, 3699, 4744],
                      ]}
                      options={{
                        title: "Chart of campaign supervision",
                        hAxis: { titleTextStyle: { color: "#333" } },
                        vAxis: { minValue: 0, title: "Calls" },
                        // For the legend to fit, we make the chart area smaller
                        chartArea: { width: "50%", height: "70%" },
                        // lineWidth: 25
                      }}
                      // For tests
                      rootProps={{ "data-testid": "1" }}
                    />
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Tổng số ĐTV</TableCell>
                          <TableCell>Làm việc</TableCell>
                          <TableCell>Nghỉ</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>46</TableCell>
                          <TableCell>36</TableCell>
                          <TableCell>10</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <Typography variant="h5" component="h3" className={classes.typo}>
              Điện thoại viên
            </Typography>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <Card>
              <CardContent>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Điện thoại viên</TableCell>
                      <TableCell>Máy lẻ</TableCell>
                      <TableCell>Trạng thái làm việc</TableCell>
                      <TableCell>Trạng thái cuộc gọi</TableCell>
                      <TableCell>Số cuộc gọi được phân bổ trong ngày</TableCell>
                      <TableCell>Chưa gọi</TableCell>
                      <TableCell>Kết nối</TableCell>
                      <TableCell>Không kết nối</TableCell>
                      <TableCell>PTP</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Nguyễn Văn A (3000)</TableCell>
                      <TableCell>1000</TableCell>
                      <TableCell>Đang gọi telesale</TableCell>
                      <TableCell>Đang gọi ra</TableCell>
                      <TableCell>100</TableCell>
                      <TableCell>30</TableCell>
                      <TableCell>50</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>xxx</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Nguyễn Văn B (3001)</TableCell>
                      <TableCell>1000</TableCell>
                      <TableCell>Đang gọi telesale</TableCell>
                      <TableCell>Đang kết nối</TableCell>
                      <TableCell>100</TableCell>
                      <TableCell>50</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>20</TableCell>
                      <TableCell>xxx</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Nguyễn Thị C (3002)</TableCell>
                      <TableCell>1000</TableCell>
                      <TableCell>Đang gọi telesale</TableCell>
                      <TableCell>Đang nghỉ</TableCell>
                      <TableCell>100</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>80</TableCell>
                      <TableCell>10</TableCell>
                      <TableCell>xxx</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </React.Fragment>
    );
  }
}

AgentUser.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AgentUser);
